export const state = getInitialState();

import { getInitialPinnedCriteria } from "./helper";

export function getInitialState() {
  return {
    preselectedFilter: null,
    savedSearches: {
      loaded: false,
      data: {
        exceptionLogs: [],
        prismsUsers: [],
        invoices: [],
        providers: [],
        levyCollectionProviders: [],
        notices: [],
        systemLogs: [],
        authenticationLogs: []
      }
    },
    pinnedCriteria: {
      loaded: false,
      loading: false,
      saving: false,
      data: getInitialPinnedCriteria()
    }
  };
}
